// tslint:disable-next-line:no-any
export default (state: any = [], action: any) => {
    switch (action.type) {
        case 'LOAD_DIVES_SUCCESS':
            if (action.dives === undefined) {
                return [];
            }
            return action.dives;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/diveReducer.ts